import { render } from "./RulePath.vue?vue&type=template&id=67ba914d&scoped=true"
import script from "./RulePath.vue?vue&type=script&lang=js"
export * from "./RulePath.vue?vue&type=script&lang=js"

import "./RulePath.vue?vue&type=style&index=0&id=67ba914d&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba914d"]])

export default __exports__